import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {VetClinicStartContextData} from "../../models/vet-clinic-start-context-data.model";
import {Subscription} from "rxjs";
import {DataGridActionButtonDef} from "../../models/data-grid-action-button-def.model";
import {CommonUtils} from "../../utils/common";
import {NextVisitReminderService} from "../../providers/next-visit-reminder.service";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {NextVisitReminderSettingsService} from "../../providers/next-visit-reminder-settings.service";
import {ModalController, PopoverController} from "@ionic/angular";
import {DataGridActionButtonsMenuComponent} from "../data-grid/data-grid-action-buttons-menu/data-grid-action-buttons-menu.component";
import {VisitLabTestData} from "../../models/visit-lab-test-data.model";
import {OrderService} from "../../providers/order.service";
import {VisitLabTestDataService} from "../../providers/visit-lab-test-data.service";
import {LabTestDataObj} from "../../models/lab-test-data-obj.model";
import {UserService} from "../../providers/user.service";
import {User} from "../../models/user.model";

@Component({
  selector: 'app-lab-test-data-for-user',
  templateUrl: './lab-test-data-for-user.component.html',
  styleUrls: ['./lab-test-data-for-user.component.scss'],
})
export class LabTestDataForUserComponent implements OnInit, OnDestroy {

  @Input() data: VisitLabTestData[];
  @Input() vetcodeId: number;
  @Output() actionCanceledEmitter = new EventEmitter<boolean>();
  @Input() userUUID: string;
  vetClinicStartContext: VetClinicStartContextData;
  subscriptions: Subscription = new Subscription();
  isBusy: boolean;
  private actionButtonsDef: DataGridActionButtonDef[];
  selectedLabTestData: VisitLabTestData;
  dataConfirmed: VisitLabTestData[];
  dataToConfirm: VisitLabTestData[];
  labTestDataObject: LabTestDataObj;
  showLabTestData: boolean;
  isLabTestDataGeneralAdmin: boolean;
  user: User;

  constructor(private commonUtils: CommonUtils,
              private nextVisitReminderService: NextVisitReminderService,
              private appStateService: AppStateService,
              private vetClinicService: VetClinicService,
              private nextVisitReminderSettingsService: NextVisitReminderSettingsService,
              private modalController: ModalController,
              private popoverController: PopoverController,
              private orderService: OrderService,
              private visitLabTestDataService: VisitLabTestDataService,
              private userService: UserService
  ) {
  }

  ngOnInit() {
    this.registerSubscription(this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    }));

    this.registerSubscription(this.userService.getUser().subscribe(it => {
      this.user = it;
      this.isLabTestDataGeneralAdmin = this.user.vClientId === null && this.user.vetcodeId === null;
    }));


    this.actionButtonsDef = [
      new DataGridActionButtonDef(
        'Przejdź do rezerwacji',
        'primary',
        (labTestData) => {
          if (labTestData) {
            this.goToReserevation(labTestData);
          }
        }, () => {
        }, (labTestData) => {
          if (labTestData) {
            return true;
          } else {
            return false;
          }
        }, true
      ),
      new DataGridActionButtonDef(
        'Otwórz wyniki badan',
        'primary',
        (labTestData) => {
          if (labTestData) {
            this.appStateService.updateIsBusySubject(true);
            this.visitLabTestDataService.getLabTestData(labTestData.uuid).subscribe(ltd => {
              this.openLabTestData(ltd);
              this.appStateService.updateIsBusySubject(false);
            }, error => {
              this.commonUtils.presentAlertToast('Nie można wyświetlić badania');
              this.appStateService.updateIsBusySubject(false);
            });
          }
        }, () => {
        }, (labTestData) => {
          if (labTestData) {
            return true;
          } else {
            return false;
          }
        }, true
      )];

    this.dataConfirmed = this.data?.filter(e => e.labTestDataConfirmed);
    this.dataToConfirm = this.data?.filter(e => !e.labTestDataConfirmed);
  }

  getDataConfirmed() {
    return this.dataConfirmed;
  }

  getDataToConfirm() {
    return this.dataToConfirm;
  }

  refresh() {
    this.registerSubscription(this.visitLabTestDataService.getLabTestDataForUser(this.userUUID).subscribe(labTestData => {
      this.data = labTestData;
      this.dataConfirmed = this.data?.filter(e => e.labTestDataConfirmed);
      this.dataToConfirm = this.data?.filter(e => !e.labTestDataConfirmed);
      this.appStateService.updateIsBusySubject(false);
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }

  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  private goToReserevation(labTestData: VisitLabTestData) {
    this.orderService.goToVetReservation(labTestData.vetineoVisitUUID)
  }

  private openLabTestData(labTestData: any) {
    this.selectedLabTestData = labTestData;
  }


  private openLabTestDataJSON(labTestData: LabTestDataObj) {
    this.labTestDataObject = labTestData;
  }

  async openMenu($event, labTestData: any) {
    if (this.actionButtonsDef && this.actionButtonsDef.length > 1) {
      const popover = await this.popoverController.create({
        component: DataGridActionButtonsMenuComponent,
        componentProps: {
          'actionButtonsDef': this.actionButtonsDef,
          'data': labTestData,
          standaloneMode: true
        },
        event: $event,
        translucent: true
      });
      await popover.present();

      const {role} = await popover.onDidDismiss();
    }
  }

  exit() {
    this.actionCanceledEmitter.emit(true);
  }

  closeEdit() {
    this.selectedLabTestData = null;
  }

  acceptTestData() {
    this.selectedLabTestData = null;
    this.refresh();
  }
}



